import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "detail"
};
var _hoisted_3 = {
  class: "detail_title"
};
var _hoisted_4 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%"
  }
};
var _hoisted_5 = {
  style: {
    "width": "9em"
  }
};
var _hoisted_6 = {
  style: {
    "width": "100%"
  }
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "detail_txt"
};
var _hoisted_9 = {
  key: 1,
  class: "detail_txt"
};
var _hoisted_10 = {
  key: 2,
  class: "detail_txt"
};
var _hoisted_11 = {
  key: 3,
  class: "detail_titles"
};
var _hoisted_12 = {
  key: 1
};
var _hoisted_13 = {
  key: 0,
  class: "link",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_14 = {
  key: 1,
  style: {
    "opacity": "0"
  },
  class: "iconfont icon-jiantoushang"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = {
  key: 4,
  class: "detail_txt"
};
var _hoisted_17 = {
  id: "dragTables"
};
var _hoisted_18 = ["onClick"];
var _hoisted_19 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_20 = {
  key: 0,
  style: {
    "position": "relative",
    "cursor": "pointer"
  }
};
var _hoisted_21 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_22 = {
  key: 0,
  style: {
    "position": "relative",
    "cursor": "pointer"
  }
};
var _hoisted_23 = ["onChange"];
var _hoisted_24 = ["onClick"];
var _hoisted_25 = ["onClick"];
var _hoisted_26 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_27 = {
  key: 0,
  style: {
    "position": "relative",
    "cursor": "pointer"
  }
};
var _hoisted_28 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_29 = {
  key: 0,
  style: {
    "position": "relative",
    "cursor": "pointer"
  }
};
var _hoisted_30 = ["onChange"];
var _hoisted_31 = ["onClick"];
var _hoisted_32 = ["onClick"];
var _hoisted_33 = {
  class: "detail_renwu"
};
var _hoisted_34 = {
  key: 0,
  class: "iconfont icon-weiwancheng1",
  style: {
    "color": "#eeb173",
    "font-size": "27px",
    "position": "absolute",
    "right": "10px",
    "top": "5px"
  }
};
var _hoisted_35 = {
  key: 1,
  class: "iconfont icon-yiwancheng1",
  style: {
    "color": "#67c173",
    "font-size": "27px",
    "position": "absolute",
    "right": "10px",
    "top": "5px"
  }
};
var _hoisted_36 = {
  key: 2,
  style: {
    "display": "flex"
  }
};
var _hoisted_37 = {
  key: 0,
  class: "detail_renwu_label"
};
var _hoisted_38 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0 10px",
    "box-sizing": "border-box"
  }
};
var _hoisted_39 = {
  key: 0,
  class: "iconfont iconshow icon-ziyuan165",
  style: {
    "color": "green"
  }
};
var _hoisted_40 = ["onClick"];
var _hoisted_41 = {
  key: 3,
  style: {
    "display": "flex"
  }
};
var _hoisted_42 = {
  key: 0,
  class: "detail_renwu_label"
};
var _hoisted_43 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0 15px",
    "box-sizing": "border-box"
  }
};
var _hoisted_44 = {
  key: 0,
  class: "iconfont iconshow icon-ziyuan165",
  style: {
    "color": "green"
  }
};
var _hoisted_45 = ["onClick"];
var _hoisted_46 = {
  style: {
    "display": "flex",
    "padding-top": "5px"
  }
};
var _hoisted_47 = {
  style: {
    "display": "inline-block",
    "min-width": "5em"
  }
};
var _hoisted_48 = {
  key: 0
};
var _hoisted_49 = ["onClick"];
var _hoisted_50 = {
  key: 0
};
var _hoisted_51 = ["onClick"];
var _hoisted_52 = ["onClick"];
var _hoisted_53 = ["onClick"];
var _hoisted_54 = {
  key: 0,
  style: {
    "display": "inline-block",
    "width": "20px"
  }
};
var _hoisted_55 = {
  key: 2
};
var _hoisted_56 = ["onClick"];
var _hoisted_57 = {
  key: 1
};
var _hoisted_58 = {
  class: "detail_member",
  style: {
    "display": "flex"
  }
};
var _hoisted_59 = {
  style: {
    "position": "relative",
    "width": "350px"
  }
};
var _hoisted_60 = {
  style: {
    "height": "100%"
  }
};
var _hoisted_61 = {
  class: "members"
};
var _hoisted_62 = ["onClick"];
var _hoisted_63 = {
  key: 0
};
var _hoisted_64 = {
  class: "members_list_left"
};
var _hoisted_65 = {
  class: "left"
};
var _hoisted_66 = {
  class: "right"
};
var _hoisted_67 = ["onClick"];
var _hoisted_68 = ["onClick"];
var _hoisted_69 = ["onClick"];
var _hoisted_70 = ["onClick"];
var _hoisted_71 = {
  key: 1,
  style: {
    "text-align": "center",
    "margin-top": "30px"
  }
};
var _hoisted_72 = {
  key: 6,
  class: "detail_txt",
  style: {
    "display": "flex"
  }
};
var _hoisted_73 = {
  style: {
    "width": "90%"
  }
};
var _hoisted_74 = {
  key: 0,
  class: "blk_link",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_75 = {
  key: 1,
  style: {
    "opacity": "0"
  },
  class: "iconfont icon-jiantoushang"
};
var _hoisted_76 = ["onClick"];
var _hoisted_77 = {
  style: {
    "text-align": "left"
  }
};
var _hoisted_78 = {
  style: {
    "text-align": "left",
    "line-height": "25px"
  }
};
var _hoisted_79 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
var _hoisted_80 = ["onClick"];
var _hoisted_81 = {
  style: {
    "font-weight": "bold",
    "font-size": "15px"
  }
};
var _hoisted_82 = {
  key: 0
};
var _hoisted_83 = {
  class: "detail_txt"
};
var _hoisted_84 = {
  class: "detail_titles"
};
var _hoisted_85 = {
  key: 0,
  class: "link",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_86 = ["onClick"];
var _hoisted_87 = {
  key: 1,
  style: {
    "opacity": "0"
  },
  class: "iconfont icon-jiantoushang"
};
var _hoisted_88 = ["onClick"];
var _hoisted_89 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_90 = ["onClick"];
var _hoisted_91 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_92 = ["onClick"];
var _hoisted_93 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_94 = ["onClick"];
var _hoisted_95 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_96 = ["onClick"];
var _hoisted_97 = {
  key: 1
};
var _hoisted_98 = {
  class: "popclose"
};
var _hoisted_99 = {
  style: {}
};
var _hoisted_100 = {
  class: "btns"
};
var _hoisted_101 = {
  style: {
    "width": "100%",
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "center"
  }
};
var _hoisted_102 = {
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "center"
  }
};
var _hoisted_103 = {
  key: 0,
  style: {
    "line-height": "23px",
    "text-align": "left",
    "margin-bottom": "10px",
    "margin-top": "0px"
  }
};
var _hoisted_104 = ["src"];
var _hoisted_105 = {
  style: {
    "line-height": "23px"
  }
};
var _hoisted_106 = {
  key: 0,
  style: {
    "line-height": "20px"
  }
};
var _hoisted_107 = {
  style: {
    "line-height": "20px"
  }
};
var _hoisted_108 = {
  style: {
    "line-height": "20px"
  }
};
var _hoisted_109 = {
  key: 3
};
import { onMounted, reactive, watchEffect, ref, nextTick } from "vue";
import { get_link, complete_link, get_tracking_info, create_link, batch_link_ctable, multiple_upload_file, updatebom_link, multiple_download_file, upload_file, linkupdateprice } from "@/api/apis";
import { useUserStore } from "@/store/user";
import { useTimStore } from "@/store/tim";
import { useConstantStore } from "@/store/constant";
import { removeRepeatKeyInArrKey, exportByXML, format, downloadUrl } from "@/util/index";
import { ElMessage } from "element-plus";
import selectMaterial from "@/views/work_bench/link_todo/material.vue";
import router from "@/router";
import Sortable from "sortablejs";
export default {
  __name: 'detail',
  props: ["id"],
  emits: ["editLink", "updateList"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emit = __emit;
    var userStore = useUserStore();
    var TimStore = useTimStore();
    var constStore = useConstantStore();
    var props = __props;
    var filebtn = ref();
    var filebtns = ref();
    var filebtn_ = ref();
    var filebtn_i = ref();
    var tableLink = ref(null);
    var data = reactive({
      showlink_quotation: false,
      //是否展示关联报价
      showWuliu: false,
      //显示物流
      wuliuDrawerTitle: "物流信息",
      dialogVisible_wl: false,
      //父项物料的弹窗
      activeInfo: "info",
      link_id: "",
      link_detail: {},
      description: "",
      value: "",
      show_member: false,
      //是否展示成员状态弹窗
      munulist: [{
        name: "未完成",
        value: 1
      }, {
        name: "已完成",
        value: 2
      }],
      current_menus: 1,
      arr_not_complete: [],
      arr_complete: [],
      arr_choose_list: [],
      checkedList: [],
      group_id: "",
      menuslist_bottom: [{
        name: "操作记录",
        value: 1
      }, {
        name: "评论",
        value: 1
      }],
      current_bottom: 0,
      remark_list: [],
      remark_keyborad: false,
      reply_keyborad: false,
      reply_id: "",
      //评论的id
      remark: "",
      //评论
      reply: "",
      //回复
      showSubmitBtn: false,
      showReplyBtn: false,
      talkShow: false,
      //是否展示回复消息的弹窗
      atList: [],
      //被@列表
      renwu: [],
      //任务列表 根据详情返回的user合并的数据
      showLog: false,
      showRemark: false,
      can_: false,
      can_see: true,
      showCloseDemo: false,
      //是否展示关闭待办的弹窗
      close_cause: "",
      //关闭待办的原因
      is_look: "",
      //是否可以看 从消息列表入
      can_complete: true,
      //是否可以点击完成 避免重复发送请求
      buhuo_dialog: false,
      editwuliu_dialog: false,
      edit_wuliu_num: "",
      buhuo_item: {},
      buhuo_num: "",
      edi_index: -1,
      //当前编辑物流单号所在下标
      show_confirm: false,
      current_operate_table_index: "",
      //正在操作的table表格项
      show_file: false,
      //是否展示附件列表
      showOperate: false,
      //是否展示操作弹窗
      file_ids: [] //批量上传的文件ids
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(function* () {
      yield nextTick(); // 确保 DOM 已经更新
      setTimeout(() => {
        if (tableLink.value) {
          initSort();
        } else {
          console.log("tableLink.value", tableLink.value);
        }
      }, 500);
    }));
    var initSort = () => {
      // const el = document.querySelector('#dragTable table tbody')
      // const el = document.querySelector('.el-table__body-wrapper tbody')
      var el = tableLink.value.$el.querySelector(".el-table__body-wrapper tbody");
      nextTick(() => {
        new Sortable(el, {
          animation: 150,
          // 动画
          onEnd: _ref3 => {
            var {
              oldIndex,
              newIndex
            } = _ref3;
            if (newIndex == oldIndex) return;
            var temp_formArr = [...data.link_detail.table];
            var oldVal = temp_formArr.splice(oldIndex, 1); //取出旧值
            temp_formArr.splice(newIndex, 0, oldVal[0]); //添加到新位置
            data.link_detail.table = []; //清空这样才会重新渲染
            nextTick(() => {
              data.link_detail.table = temp_formArr;
            });
          }
        });
      });
    };

    //更新表格
    var handle_update = type => {
      if (type == 1) {
        linkupdateprice({
          link_id: data.link_id
        }, "POST").then(res => {
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: "操作成功"
            });
          }
        });
      } else {
        updatebom_link({
          link_id: data.link_id
        }, "POST").then(res => {
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: "操作成功"
            });
          }
        });
      }
    };

    // 导出表格
    var handle_export = () => {
      var now = format(new Date().getTime() / 1000).split(":")[0];
      // console.log({now})
      var title = data.link_detail.source_name + " " + data.link_detail.theme + " " + now.split(" ")[0] + "-" + now.split(" ")[1] + ".xlsx";
      // console.log({title})
      exportByXML({
        link_id: data.link_id
      }, "/api/custom_excel_export", title);
    };

    // 获取当前用户的任务
    var getRole = type => {
      var role_types = [];
      var bollean = false;
      data.link_detail.user.map(x => {
        if (x.link_user_id == userStore.info.id) {
          role_types.push(x.type);
        }
      });
      if (role_types.indexOf(type) != -1) {
        bollean = true;
      } else {
        bollean = false;
      }
      return bollean;
    };
    // 获取label
    var getTypeLabel = type => {
      if (type == 2) {
        return "售后";
      } else if (type == 3) {
        return "测试组";
      } else if (type == 4) {
        return "制图";
      } else if (type == 5) {
        return "文员";
      } else if (type == 6) {
        return "销售员";
      } else if (type == 7) {
        return "计划";
      } else if (type == 8) {
        return "销售员";
      }
      return "人员";
    };

    // 判断计划是否已经确认
    var checkplanok = () => {
      var plan = data.renwu.find(x => x.type == 7);
      return plan.selected && plan.selected.length > 0 && plan.selected.every(x => x.status == 2);
    };

    //判断是否可以看到产品图纸
    var canSeeProduct = () => {
      if (!getRole(4) && !getRole(7) && !getRole(5) && !checkplanok()) {
        return false;
      }
      return true;
    };

    //下载图纸
    var handle_download = (type, id, num) => {
      var obj = {
        type,
        link_id: id
      };
      if (num) {
        obj["num"] = num;
      }
      console.log("obj-->", obj);
      multiple_download_file(obj, "POST").then(res => {
        if (res.code == 200) {
          downloadUrl(res.data);
        }
      });
    };

    // 去报价
    var handle_to_quotation = () => {
      //跳转到新建报价页面，并将link_id带过去
      router.push("/work_bench/quotation_add?link_id=".concat(data.link_id));
    };

    // 表格单条数据的保存按钮
    var handle_save_item = () => {
      // 过滤数组中物料id为空的数据
      // let no_id = data.link_detail.table.filter(x => !x.bd_material_id)
      // if (no_id && no_id[0] && type != 'delete') {
      //     ElMessage({
      //         type: 'warning',
      //         message: '物料不能为空'
      //     })
      //     return false
      // }
      var index_n = data.link_detail.user.findIndex(x => x.link_user_id == userStore.info.id);
      var obj = {
        id: data.link_detail.user[index_n].id,
        //是当前登录用户所在任务的id
        table: data.link_detail.table,
        finish_type: 2
      };
      // 做校验是否有物料  将没有的物料过滤掉直接保存
      obj.table = JSON.parse(JSON.stringify(obj.table)).filter(x => x.bd_material_id);
      obj.table.forEach((x, i) => {
        x.order = i + 1;
      });
      complete_link(obj, "POST").then(res => {
        if (res.code == 200) {
          getLinkDetail(data.link_id);
          ElMessage({
            type: "success",
            message: "保存成功"
          });
        }
      });
    };
    // 确定删除
    var handleConfirm = index => {
      // 确认删除表格中的current_operate_table_index 数据
      if (!data.link_detail.table[index].id) {
        data.link_detail.table.splice(index, 1);
        // 若不存在id 说明本就没有这条数据 不用走接口
        return false;
      }
      data.link_detail.table.splice(index, 1);
      handle_save_item();
    };

    // 删除附件
    var handle_delete_drawing = (index, key) => {
      data.link_detail.table[index][key] = {};
      if (data.link_detail.table[index].bd_material_id) {
        handle_save_item();
      }
    };

    // 文件上传成功
    var handleSignDrawingSuccess = (filename, res, index) => {
      data.link_detail.table[index].sign_drawing = {};
      data.link_detail.table[index].sign_drawing = {
        file_name: filename,
        file_url: res.data.file_url,
        file_id: res.data.file_id
      };
      if (data.link_detail.table[index].bd_material_id) {
        handle_save_item();
      }
    };
    //批量上传产品图纸及客户签字图纸
    var handle_file_selectted = (e, task, index) => {
      console.log("获取上传文件的列表", e.target.files, index, e.target.value);
      var type = task == "上传产品图纸" ? 1 : 2;
      if (index != undefined) {
        var files = Array.from(e.target.files);
        var file = files[0];
        var filename = file.name;
        var formData = new FormData();
        formData.append("content_type", 6);
        formData.append("file", file);
        files = [];
        file = null;
        if (type == 1) {
          console.log("a->", filebtns.value.value);
          filebtns.value.value = "";
        } else {
          filebtn_i.value.value = "";
        }
        e.target.value = "";
        upload_file(formData, "POST").then(res => {
          if (type == 1) {
            handleDrawingSuccess(filename, res, index);
          }
          if (type == 2) {
            handleSignDrawingSuccess(filename, res, index);
          }
          filename = "";
        });
      } else {
        var _files = Array.from(e.target.files);
        if (_files && _files[0]) {
          var _formData = new FormData();
          _files.forEach((file, index) => {
            _formData.append("files[".concat(index, "]"), file);
          });
          _formData.append("content_type", 6);
          if (type == 1) {
            filebtn.value.value = "";
          } else {
            filebtn_.value.value = "";
          }
          _files = [];
          e.target.value = "";
          // 将图片上传到服务器并返回一个url地址
          multiple_upload_file(_formData).then(res => {
            var _data$link_detail$use;
            console.log("获取到的上传文件->", res);
            var taskid_upload_sign = (_data$link_detail$use = data.link_detail.user.find(x => x.title == task)) === null || _data$link_detail$use === void 0 ? void 0 : _data$link_detail$use.task_id;
            var file_arr = res.data || [];
            if (file_arr && file_arr[0]) {
              var obj = {
                link_id: data.link_id,
                link_task_id: taskid_upload_sign,
                file_ids: file_arr.map(x => x.file_id),
                type: type
              };
              batch_link_ctable(obj, "POST").then(res => {
                getLinkDetail(data.link_id);
              });
            }
          });
        }
      }
    };
    var handleDrawingSuccess = (filename, res, index) => {
      data.link_detail.table[index].drawing = {};
      data.link_detail.table[index].drawing = {
        file_name: filename,
        file_url: res.data.file_url,
        file_id: res.data.file_id
      };
      if (data.link_detail.table[index].bd_material_id) {
        handle_save_item();
      }
    };

    // 获取待办详情
    var getLinkDetail = id => {
      if (!id) return;
      var obj = {
        id: id
      };
      if (data.is_look == "true") {
        obj.is_look = "true";
      }
      get_link(obj).then(res => {
        data.link_detail = res.data.list[0];
        var index_ = data.link_detail.user.findIndex(x => x.type == 2);
        if (index_ != -1) {
          data.buhuo_item.tracking_number_task_id = data.link_detail.user[index_].task_id;
          if (data.link_detail.user[index_].content.length > 0) {
            data.link_detail.wuliu_arr = data.link_detail.user[index_].content.split(",");
            data.buhuo_item.wuliu_arr = data.link_detail.wuliu_arr;
          } else {
            data.link_detail.wuliu_arr = [];
            data.buhuo_item.wuliu_arr = [];
          }
        }
        console.log("获取详情--->", data.link_detail);
        if (data.link_detail.copy && data.link_detail.copy[0]) {
          data.link_detail.copy[0].show = true;
        }
        // if (data.link_detail.copy && data.link_detail.copy[0]) {
        //     data.link_detail.copy.forEach(m => {
        //         let temp_arr_user = JSON.parse(JSON.stringify(m.user));
        //         let temp_arr = [];
        //         temp_arr_user.map(x => {
        //             temp_arr.push({
        //                 task_id: x.task_id,
        //                 selected: [{
        //                     name: x.user_name,
        //                     link_user_id: x.link_user_id,
        //                     id: x.id,
        //                     status: x.status,
        //                     checked: x.status == 2 ? true : false
        //                 }],
        //                 title: x.title,
        //                 finish_time: x.finish_time,
        //                 type: x.type,
        //                 content: x.content,
        //             })
        //         })
        //         const mergedData = temp_arr.reduce((result, current) => {
        //             const existingItem = result.find(item => item.task_id === current.task_id);
        //             if (existingItem) {
        //                 existingItem.selected = existingItem.selected.concat(current.selected);
        //             } else {
        //                 result.push(current);
        //             }
        //             return result;
        //         }, []);
        //         m.renwu = mergedData;
        //     })
        // }

        handle_classify_member();
        data.group_id = data.link_detail.group_id;
        var arr = removeRepeatKeyInArrKey(data.link_detail.user, "link_user_id");
        if (arr.length > 3) {
          data.description = arr.slice(0, 3).map(x => x.user_name);
        } else {
          data.description = arr.map(x => x.user_name);
        }
        var num = 0;
        data.link_detail.user.map(x => {
          if (x.status == 2) {
            num = num + 1;
          }
        });
        data.description = data.description.join(",") + "等" + arr.length + "人执行，" + num + "/" + data.link_detail.user.length + "已完成";
        var temp_arr_user = JSON.parse(JSON.stringify(data.link_detail.user));
        var temp_arr = [];
        temp_arr_user.map(x => {
          temp_arr.push({
            task_id: x.task_id,
            selected: [{
              name: x.user_name,
              link_user_id: x.link_user_id,
              id: x.id,
              status: x.status,
              checked: x.status == 2 ? true : false
            }],
            title: x.title,
            finish_time: x.finish_time,
            confirm_time: x.confirm_time,
            type: x.type,
            content: x.content
          });
        });
        console.log("temp_arr-->", temp_arr);
        // 使用reduce方法进行合并 对数据中有相同task_id的数据进行合并
        var mergedData = temp_arr.reduce((result, current) => {
          var existingItem = result.find(item => item.task_id === current.task_id);
          if (existingItem) {
            existingItem.selected = existingItem.selected.concat(current.selected);
          } else {
            result.push(current);
          }
          return result;
        }, []);
        data.renwu = mergedData;
        console.log("data.renmwu--->", data.renwu);
        var can_ = false;
        // 首先判断该条link待办是否有未完成的任务 若有 再判断未完成的任务中的人员是创建者还是成员
        var arr_status_2 = [];
        arr_status_2 = data.link_detail.user.filter(x => x.status != 2);
        if (arr_status_2 && arr_status_2[0]) {
          if (data.link_detail.user_id == userStore.info.id) {
            can_ = true;
          }
        } else {
          can_ = false;
        }
        data.can_ = can_;
        if (data.link_detail.view_status == 2) {
          var index_mine = data.link_detail.user.findIndex(x => x.link_user_id == userStore.info.id);
          var isCreate = data.link_detail.user_id == userStore.info.id;
          if (isCreate || index_mine != -1) {
            data.can_see = true;
          } else {
            data.can_see = false;
          }
        }
      });
    };
    watchEffect(() => {
      if (props.id) {
        // 获取link详情
        data.link_id = props.id;
        getLinkDetail(props.id);
      }
    });

    // 区分·出已完成人员和未完成人员
    var handle_classify_member = () => {
      if (data.link_detail.user) {
        // 区分出已完成和未完成的人员列表
        var arr_not_complete = [];
        var arr_complete = [];
        data.link_detail.user.map(x => {
          if (x.status == 2) {
            arr_complete.push(x);
          } else {
            arr_not_complete.push(x);
          }
        });
        data.arr_complete = arr_complete;
        data.arr_not_complete = arr_not_complete;
      }
    };

    // 操作
    var handle_operate = (v, m) => {
      console.log("操作栏---->", v, m);
      var obj = {
        id: v.id
      };
      if (m == 1) {
        // 此时是标记未完成
        obj.status = 1;
      } else if (m == 2) {
        obj.status = -1;
        // 此时是移除成员
      } else if (m == 3) {
        console.log("发送催办消息");
        // 此时是催办 向群组列表发送一条自定义消息 提醒他去做这个待办
        var _obj = {
          title: data.link_detail.title,
          date: data.link_detail.date,
          desc: data.description,
          origin_id: data.link_id,
          theme: data.link_detail.theme,
          link_id: data.link_id
        };
        TimStore.TIMSendCustomMessage(v.user_name, "link", JSON.stringify(_obj), "C2C", "催办待办").then(res => {
          if (res == "success") {
            ElMessage({
              type: "success",
              message: "催办成功"
            });
          }
        }).catch(err => {
          ElMessage({
            type: "error",
            message: "催办失败"
          });
        });
      } else if (m == 4) {
        // 此时是完成
        obj.status = 2;
      }
      if (m == 1 || m == 4 || m == 2) {
        complete_link(obj, "POST").then(res => {
          if (res.code == 200) {
            // 完成待办的时候需发送完成待办的提醒 此时只有一个待办
            console.log("完成待办---->", v);
            var item = JSON.parse(JSON.stringify(v));
            var user_need_send_message = JSON.parse(JSON.stringify(data.link_detail.user));
            getLinkDetail(data.link_id);
            // 通知父组件更新link列表
            emit("updateList");
            if (data.link_detail.type != 3) {
              setTimeout(() => {
                if (m == 4) {
                  TimStore.TIMSendCustomMessage(v.user_name, "link", JSON.stringify(obj), "C2C", "催办待办");
                  send_complete_custom(item, user_need_send_message);
                }
              }, 500);
            }
            data.showOperate = false;
            data.current_menus = 1;
          }
        });
      }
    };

    // 在待办表格中添加数据
    var handle_add_material = () => {
      data.link_detail.table.push({
        bd_material_model: "",
        //规格型号
        bd_material_name: "",
        //物料名称
        drawing: {},
        //产品图纸
        sign_drawing: {},
        //客户签字图纸
        list_price: "",
        //目录价
        upload_time: "",
        //上传时间
        number: 1,
        casing_number: "",
        carton_size: ""
      });
    };
    var send_complete_custom = (item, user_need_send_message) => {
      console.log("item-->", item);
      var obj = {
        title: data.link_detail.title,
        date: data.link_detail.date,
        desc: data.description,
        origin_id: data.link_id,
        theme: data.link_detail.theme,
        link_id: data.link_id,
        notice: "yes"
      };
      var desc = "";
      if (item.status != 2) {
        // 说明此时的待办还是未完成且被点击需要完成的待办
        if (item.link_user_id == userStore.info.id) {
          desc = "".concat(userStore.info.name, "\u5B8C\u6210\u4E86").concat(item.title);
        } else if (item.link_user_id != userStore.info.id) {
          desc = "".concat(userStore.info.name, "\u5B8C\u6210\u4E86").concat(item.user_name ? item.user_name : item.name, "\u7684\u4EFB\u52A1\uFF1A").concat(item.title);
        }
        obj.desc_notice = desc;
        console.log("obj.desc_notice--->", obj.desc_notice);
        // 要看相同的task_id下面还有没有别的成员  如果有别的成员 需要给每一个任务相关人员发送消息
        var task_id_arr = user_need_send_message.filter(x => {
          return x.task_id == item.task_id && x.link_user_id != userStore.info.id;
        });
        var index_create = task_id_arr.findIndex(x => x.link_user_id == data.link_detail.user_id);
        if (index_create == -1) {
          console.log("此时创建者不在任务表");
          if (data.link_detail.user_id != userStore.info.id) {
            TimStore.TIMSendCustomMessage(data.link_detail.create_user, "link", JSON.stringify(obj), "C2C", "提醒");
          }
        }
        console.log("task_id_arr----->", task_id_arr);
        for (var i in task_id_arr) {
          console.log("可以发，发给-", task_id_arr[i].user_name, "desc--->", obj.desc_notice);
          TimStore.TIMSendCustomMessage(task_id_arr[i].user_name, "link", JSON.stringify(obj), "C2C", "提醒");
        }
      }
    };
    var handle_complete = (v, item_) => {
      // white_type_material 定制品待办任务的type白名单 用于区分
      var white_type_material = [4, 5, 6, 7, 8];
      var id = "";
      if (white_type_material.indexOf(item_.type) == -1) {
        id = v.id;
      } else {
        var id_arr = [];
        item_.selected.map(x => {
          if (x.status != 2) {
            id_arr.push(x.id);
          }
        });
        id = id_arr.join(",");
      }
      console.log("完成000-->", v, item_);
      if (data.can_complete == true) {
        data.can_complete = false;
        var obj = {
          id: id,
          status: 2
        };
        console.log("obj-->", obj);
        if (item_.type == 2) {
          if (item_.content == "") {
            ElMessage({
              type: "error",
              message: "物流单号不可为空"
            });
            data.can_complete = true;
            return false;
          }
        }
        if (item_.type == 3) {
          // 判断售后是否已完成任务
          var shouhou = data.link_detail.user.filter(x => x.type == 2);
          console.log("shouhou--->", shouhou);
          if (shouhou) {
            var index_status = shouhou.findIndex(x => x.status != 2);
            if (index_status != -1) {
              ElMessage({
                type: "warning",
                message: "待售后完成"
              });
              data.can_complete = true;
              return false;
            }
          }
        }
        if (item_.type == 6) {
          // 判断签名图纸是否已经上传
          if (data.link_detail.table.filter(x => {
            var _x$sign_drawing;
            return !(x !== null && x !== void 0 && (_x$sign_drawing = x.sign_drawing) !== null && _x$sign_drawing !== void 0 && _x$sign_drawing.file_name);
          }).length > 0 || !data.link_detail.table || data.link_detail.table.length == 0) {
            ElMessage({
              type: "warning",
              message: "请上传客户签名图纸"
            });
            data.can_complete = true;
            return false;
          }
        }
        complete_link(obj, "POST").then(res => {
          if (res.code == 200) {
            data.can_complete = true;
            var user_need_send_message = JSON.parse(JSON.stringify(data.link_detail.user));
            var item = JSON.parse(JSON.stringify(v));
            item.task_id = item_.task_id;
            item.title = item_.title;
            getLinkDetail(data.link_id);

            // 通知父组件更新link列表
            emit("updateList");

            //更新用户信息
            userStore.getInfo().then(res => {
              console.log("res---info->", res);
            });
            if (data.link_detail.type == 3) {
              return false;
            }
            setTimeout(() => {
              // 这里需要标识一下是否是一个人完成待办之后刷新另外三人的待办状态，是否发送消息
              send_complete_custom(item, user_need_send_message);
            }, 500);
          }
        });
      }
    };
    // 选择物料
    var handle_choose_material = (v, i) => {
      console.log("v,i-->", v, i);
      var id = v.bd_material_id ? v.bd_material_id : "";
      data.current_operate_table_index = i;
      console.log("getRole(4)", getRole(4));
      if (getRole(4)) {
        console.log("可以");
        data.dialogVisible_wl = true;
      }
    };

    // 获取当前选中数据
    var getSelectData = selectdata => {
      data.dialogVisible_wl = false;
      data.link_detail.table[data.current_operate_table_index].bd_material_id = selectdata.id;
      data.link_detail.table[data.current_operate_table_index].bd_material_model = selectdata.model;
      data.link_detail.table[data.current_operate_table_index].bd_material_name = selectdata.name;
      data.link_detail.table[data.current_operate_table_index].list_price = selectdata.list_price;
      data.link_detail.table[data.current_operate_table_index].casing_number = selectdata.casing_number;
      data.link_detail.table[data.current_operate_table_index].carton_size = selectdata.carton_size;
      if (selectdata.drawing && selectdata.drawing[0]) {
        var drawing = {
          file_name: selectdata.drawing[0].name,
          file_id: selectdata.drawing[0].file_id,
          file_url: selectdata.drawing[0].url
        };
        console.log("drawing-->", drawing);
        data.link_detail.table[data.current_operate_table_index].drawing = drawing;
      }
      handle_save_item();
      // if (selectdata.sign_drawing && selectdata.sign_drawing[0]) {
      //     let sign_drawing = {
      //         file_name: selectdata.sign_drawing[0].name,
      //         file_id: selectdata.sign_drawing[0].file_id,
      //         file_url: selectdata.sign_drawing[0].url
      //     }
      //     data.link_detail.table[data.current_operate_table_index].sign_drawing = sign_drawing;
      // }
    };
    var handle_mouse_enter_operate = () => {
      if (data.link_detail.status == 4) {
        return false;
      }
      data.showOperate = true;
      data.arr_choose_list = data.arr_not_complete;
    };

    // 显示操作
    var handle_showOperate = () => {
      if (data.link_detail.status == 4) {
        return false;
      }
      data.showOperate = !data.showOperate;
      data.arr_choose_list = data.arr_not_complete;
    };

    // 切换tabs
    var changeMenus = v => {
      data.current_menus = v.value;
      data.arr_choose_list = data.current_menus == 1 ? data.arr_not_complete : data.arr_complete;
    };
    // 编辑详情
    var handle_edit = () => {
      // 弹出待办编辑页的详情
      // 向父组件传递事件 关闭link详情弹窗打开编辑弹窗
      emit("editLink", data.link_id, false);
    };

    // 关闭待办
    var handle_close = () => {
      console.log("关闭待办---》");
      data.showCloseDemo = !data.showCloseDemo;
    };
    var handle_submit_desc = str => {
      var obj = {
        id: data.link_id
      };
      if (str && str == "close_cause") {
        if (data.close_cause && data.close_cause != "") {
          obj.close_cause = data.close_cause;
          obj.status = 4;
        } else {
          ElMessage({
            type: "warning",
            message: "原因不能为空"
          });
          return false;
        }
      } else {
        obj.description = data.link_detail.description;
        obj.description_change = 1;
      }
      create_link(obj, "PUT").then(res => {
        console.log("更新link成功---->", res);
        getLinkDetail(data.link_id);
        if (res.code == 200) {
          ElMessage({
            type: "success",
            message: "操作成功"
          });
          data.showCloseDemo = false;
        }
      });
    };
    var handle_click_url = url => {
      console.log({
        url
      });
      var eleLink = document.createElement("a");
      eleLink.href = url; // 触发点击
      eleLink.target = "_blank";
      document.body.appendChild(eleLink);
      eleLink.click(); // 然后移除
      document.body.removeChild(eleLink);
    };

    // 跳转到样品申请详情
    var handle_to_sample = () => {
      router.push("/work_bench/sample_detail/" + data.link_detail.origin_id);
    };

    // 补货
    var handle_buhuo = item => {
      console.log("补货---->", item);
      data.buhuo_num = "";
      data.buhuo_dialog = true;
      // buhuo_item = item;
    };

    //确定补货
    var pass_buhuo = num => {
      console.log("data.buhuoitem--->", data.buhuo_item);
      if (data.edi_index != -1) {
        data.buhuo_item.wuliu_arr[data.edi_index] = data.edit_wuliu_num;
      }
      console.log("data.buhuoitem--->", data.buhuo_item);
      if (num == 1 && data.buhuo_num) {
        console.log("data.buhuo_num---->", data.buhuo_num);
        data.buhuo_item.wuliu_arr.push(data.buhuo_num);
      }
      console.log("data.buhuoitem--->", data.buhuo_item);
      var str = data.buhuo_item.wuliu_arr.join(",");
      console.log("str-------->", str);
      if (data.buhuo_num || data.edit_wuliu_num) {
        var obj_2 = {
          content: str,
          task_id: data.buhuo_item.tracking_number_task_id
        };
        complete_link(obj_2, "POST").then(res => {
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: "操作成功"
            });
            getLinkDetail(data.link_id);
            data.buhuo_dialog = false;
            data.editwuliu_dialog = false;
          }
        });
      } else {
        ElMessage({
          type: "error",
          message: "请输入物流单号"
        });
      }
    };
    // 编辑物流
    var handle_edit_wuliu = (v, i) => {
      console.log("编辑物流---->", v, i);
      data.editwuliu_dialog = true;
      data.edit_wuliu_num = v;
      data.link_detail.wuliu_arr[i] = data.edit_wuliu_num;
      data.edi_index = i;
    };
    // 删除物流
    var handle_del_wuliu = (v, i) => {
      console.log("删除物流---->", v, i);
      data.link_detail.wuliu_arr.splice(i, 1);
      var str = data.buhuo_item.wuliu_arr.join(",");
      var obj_2 = {
        content: str,
        task_id: data.buhuo_item.tracking_number_task_id
      };
      complete_link(obj_2, "POST").then(res => {
        if (res.code == 200) {
          ElMessage({
            type: "success",
            message: "操作成功"
          });
          getLinkDetail(data.link_id);
          data.buhuo_dialog = false;
          data.editwuliu_dialog = false;
        }
      });
    };
    var activities = ref([]);
    // 展示物流信息
    var handle_show_wuliuInfo = m => {
      data.wuliuDrawerTitle = m + " 的物流信息";
      data.showWuliu = true;
      get_tracking_info({
        tracking_number: m
      }).then(res => {
        console.log("获取物流的结构--->");
        if (res.code == 200) {
          activities.value = res === null || res === void 0 ? void 0 : res.data;
        }
      });
    };

    // 待办关联报价跳转详情
    var handle_to_sn = v => {
      router.push({
        path: "/work_bench/quotation_detail/" + v.id,
        query: {
          id: v.id,
          auth: "view"
        }
      });
    };

    // 再次创建待办
    var handle_to_createlink = () => {
      //显示创建待办的弹窗 关闭详情弹窗
      emit("editLink", data.link_detail.id, true);
    };
    return (_ctx, _cache) => {
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_popconfirm = _resolveComponent("el-popconfirm");
      var _component_el_table = _resolveComponent("el-table");
      var _component_el_divider = _resolveComponent("el-divider");
      var _component_common_area = _resolveComponent("common-area");
      var _component_el_tab_pane = _resolveComponent("el-tab-pane");
      var _component_el_timeline_item = _resolveComponent("el-timeline-item");
      var _component_el_timeline = _resolveComponent("el-timeline");
      var _component_el_tabs = _resolveComponent("el-tabs");
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _component_el_card = _resolveComponent("el-card");
      var _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock(_Fragment, null, [data.can_see ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: data.activeInfo,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.activeInfo = $event),
        style: {
          "margin-top": "-20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "基本信息",
          name: "info"
        }, {
          default: _withCtx(() => {
            var _data$link_detail, _data$link_detail2;
            return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(data.link_detail.theme) + "   ", 1), data.link_detail.type == 3 && checkplanok() ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              class: "box-item",
              effect: "dark",
              content: "一键报价",
              placement: "top"
            }, {
              default: _withCtx(() => [data.link_detail.type == 3 ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "blk_link iconfont icon-xingzhuang3x",
                style: {
                  "font-size": "15px",
                  "cursor": "pointer"
                },
                onClick: handle_to_quotation
              })) : _createCommentVNode("", true)]),
              _: 1
            })) : _createCommentVNode("", true), _cache[27] || (_cache[27] = _createTextVNode("   ")), data.link_detail.type == 3 ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 1,
              class: "box-item",
              effect: "dark",
              content: "一键改图",
              placement: "top"
            }, {
              default: _withCtx(() => [data.link_detail.type == 3 ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "blk_link iconfont icon-tianjia",
                style: {
                  "font-size": "15px",
                  "cursor": "pointer"
                },
                onClick: handle_to_createlink
              })) : _createCommentVNode("", true)]),
              _: 1
            })) : _createCommentVNode("", true), _cache[28] || (_cache[28] = _createTextVNode("    ")), data.link_detail.task_status != 4 && data.link_detail.status != 2 && (data.link_detail.type != 1 || data.link_detail.type == 1 && data.link_detail.user_id == _unref(userStore).info.id) ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "iconfont icon-shanchu",
              style: {
                "color": "#bfbfbf"
              },
              onClick: handle_close
            })) : _createCommentVNode("", true), data.link_detail.type == 3 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              size: "small",
              style: {
                "float": "right"
              },
              onClick: handle_export
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("导出表格")])),
              _: 1
            })) : _createCommentVNode("", true), data.link_detail.type == 3 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 4,
              type: "primary",
              size: "small",
              style: {
                "float": "right",
                "margin-right": "10px"
              },
              onClick: handle_update
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("更新bom")])),
              _: 1
            })) : _createCommentVNode("", true), data.link_detail.type == 3 && data.link_detail.canUpdatePrice ? (_openBlock(), _createBlock(_component_el_button, {
              key: 5,
              type: "primary",
              size: "small",
              style: {
                "float": "right",
                "margin-right": "0px"
              },
              onClick: _cache[0] || (_cache[0] = $event => handle_update(1))
            }, {
              default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("更新价格")])),
              _: 1
            })) : _createCommentVNode("", true)]), data.link_detail.type == 3 && data.link_detail.quotations[0] ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[29] || (_cache[29] = _createElementVNode("span", null, "报价关联单：", -1)), data.link_detail.quotations.length > 1 ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = $event => data.showlink_quotation = !data.showlink_quotation),
              class: _normalizeClass(['iconfont', 'link', data.showlink_quotation ? 'icon-jiantoushang' : 'icon-jiantouxia'])
            }, null, 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.link_detail.quotations, (v, i) => {
              return _openBlock(), _createElementBlock("div", {
                class: "link",
                style: {
                  "cursor": "pointer"
                },
                key: v
              }, [i == 0 || data.showlink_quotation ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: $event => handle_to_sn(v)
              }, _toDisplayString(v.sn), 9, _hoisted_7)) : _createCommentVNode("", true)]);
            }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, " 申请人：" + _toDisplayString(data.link_detail.create_user), 1), data.link_detail.source_name ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 来源：" + _toDisplayString(data.link_detail.source_name), 1)) : _createCommentVNode("", true), data.link_detail.bills_code ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[30] || (_cache[30] = _createTextVNode(" 样品申请单号：")), _createElementVNode("span", {
              class: "link",
              onClick: handle_to_sample,
              style: {
                "cursor": "pointer"
              }
            }, _toDisplayString(data.link_detail.bills_code), 1)])) : _createCommentVNode("", true), data.link_detail.title ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createTextVNode(_toDisplayString(data.link_detail.type == 2 ? "样品返厂原因" : data.link_detail.type == 3 ? "客户需求" : "待办描述") + "：" + _toDisplayString(data.link_detail.title) + " ", 1), data.link_detail.table && data.link_detail.table[0] ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "iconfont icon-baocun link",
              style: {
                "float": "right",
                "font-size": "21px",
                "margin-bottom": "5px"
              },
              onClick: handle_save_item
            })) : _createCommentVNode("", true), data.link_detail.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.link_detail.file, (v, i) => {
              return _openBlock(), _createElementBlock("div", {
                style: {
                  "line-height": "20px",
                  "padding-left": "5em"
                },
                key: i
              }, [data.show_file && i != 0 || i == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [i == 0 && data.link_detail.file.length > 1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass({
                  iconfont: true,
                  'icon-jiantoushang': !data.show_file,
                  'icon-jiantouxia': data.show_file
                }),
                onClick: _cache[2] || (_cache[2] = _withModifiers($event => data.show_file = !data.show_file, ["stop"]))
              }, " ", 2)) : _createCommentVNode("", true), i > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_14, " ")) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "link",
                style: {
                  "display": "inline-block",
                  "width": "90%",
                  "cursor": "pointer"
                },
                onClick: $event => handle_click_url(v.file_url)
              }, _toDisplayString(v.name), 9, _hoisted_15)])) : _createCommentVNode("", true)]);
            }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), data !== null && data !== void 0 && (_data$link_detail = data.link_detail) !== null && _data$link_detail !== void 0 && (_data$link_detail = _data$link_detail.projects) !== null && _data$link_detail !== void 0 && _data$link_detail.project ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[31] || (_cache[31] = _createTextVNode(" 客户项目：")), _createElementVNode("span", null, _toDisplayString(data === null || data === void 0 || (_data$link_detail2 = data.link_detail) === null || _data$link_detail2 === void 0 || (_data$link_detail2 = _data$link_detail2.projects) === null || _data$link_detail2 === void 0 ? void 0 : _data$link_detail2.project), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [data.link_detail.type == 3 ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              ref_key: "tableLink",
              ref: tableLink,
              data: data.link_detail.table,
              border: "",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "序列",
                width: "55"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.$index + 1), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "规格型号",
                prop: "bd_material_model",
                width: "120",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(scope => [_createElementVNode("span", {
                  class: _normalizeClass({
                    link: getRole(4),
                    pointers: getRole(4)
                  }),
                  onClick: $event => handle_choose_material(scope.row, scope.$index)
                }, _toDisplayString(scope.row.bd_material_model ? scope.row.bd_material_model : getRole(4) ? "选择物料" : "-"), 11, _hoisted_18)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "物料名称",
                width: "150",
                prop: "bd_material_name",
                "show-overflow-tooltip": ""
              }), _createVNode(_component_el_table_column, {
                label: "箱规",
                width: "100",
                prop: "carton_size",
                "show-overflow-tooltip": ""
              }), _createVNode(_component_el_table_column, {
                label: "装箱数量",
                width: "100",
                prop: "casing_number",
                "show-overflow-tooltip": ""
              }), _createVNode(_component_el_table_column, {
                label: "bom版本",
                prop: "bd_material_versions",
                width: "100"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_input, {
                  modelValue: scope.row.bd_material_versions,
                  "onUpdate:modelValue": $event => scope.row.bd_material_versions = $event
                }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "数量",
                prop: "number",
                width: "100"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: scope.row.number,
                  "onUpdate:modelValue": $event => scope.row.number = $event,
                  min: 1
                }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                _: 1
              }), data.link_detail.canSeeProduct ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "产品图纸",
                "min-width": "130",
                prop: "drawing"
              }, {
                header: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_cache[33] || (_cache[33] = _createTextVNode(" 产品图纸   ")), getRole(4) ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("input", {
                  type: "file",
                  ref_key: "filebtn",
                  ref: filebtn,
                  multiple: "",
                  onChange: _cache[3] || (_cache[3] = $event => handle_file_selectted($event, '上传产品图纸')),
                  style: {
                    "position": "absolute",
                    "top": "0",
                    "right": "0",
                    "width": "100%",
                    "height": "100%",
                    "opacity": "0",
                    "cursor": "pointer"
                  }
                }, null, 544), _cache[32] || (_cache[32] = _createElementVNode("span", {
                  class: "link iconfont icon-shangchuanfujian"
                }, null, -1))])) : _createCommentVNode("", true), _cache[34] || (_cache[34] = _createTextVNode("    ")), _createElementVNode("span", {
                  class: "link iconfont icon-xiazai",
                  onClick: _cache[4] || (_cache[4] = $event => handle_download(1, data.link_id))
                })])]),
                default: _withCtx(scope => [_createElementVNode("div", _hoisted_21, [getRole(4) ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("input", {
                  type: "file",
                  ref_key: "filebtns",
                  ref: filebtns,
                  onChange: $event => handle_file_selectted($event, '上传产品图纸', scope.$index),
                  style: {
                    "position": "absolute",
                    "top": "0",
                    "right": "0",
                    "width": "100%",
                    "height": "100%",
                    "opacity": "0",
                    "cursor": "pointer"
                  }
                }, null, 40, _hoisted_23), _cache[35] || (_cache[35] = _createElementVNode("span", {
                  class: "link iconfont icon-shangchuanfujian"
                }, null, -1))])) : _createCommentVNode("", true), _createElementVNode("span", {
                  onClick: $event => handle_click_url(scope.row.drawing.file_url),
                  class: "pointers link"
                }, _toDisplayString(scope.row.drawing.file_name) + "   ", 9, _hoisted_24), scope.row.drawing.file_name && getRole(4) ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "iconfont icon-shanchu",
                  onClick: $event => handle_delete_drawing(scope.$index, 'drawing')
                }, null, 8, _hoisted_25)) : _createCommentVNode("", true)])]),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
                label: "签字图纸",
                prop: "sign_drawing",
                "min-width": "130"
              }, {
                header: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_cache[37] || (_cache[37] = _createTextVNode(" 签字图纸   ")), getRole(6) ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("input", {
                  type: "file",
                  ref_key: "filebtn_",
                  ref: filebtn_,
                  multiple: "",
                  onChange: _cache[5] || (_cache[5] = $event => handle_file_selectted($event, '上传客户签名图纸')),
                  style: {
                    "position": "absolute",
                    "top": "0",
                    "right": "0",
                    "width": "100%",
                    "height": "100%",
                    "opacity": "0",
                    "cursor": "pointer"
                  }
                }, null, 544), _cache[36] || (_cache[36] = _createElementVNode("span", {
                  class: "link iconfont icon-shangchuanfujian"
                }, null, -1))])) : _createCommentVNode("", true), _cache[38] || (_cache[38] = _createTextVNode("    ")), _createElementVNode("span", {
                  class: "link iconfont icon-xiazai",
                  onClick: _cache[6] || (_cache[6] = $event => handle_download(2, data.link_id))
                })])]),
                default: _withCtx(scope => [_createElementVNode("div", _hoisted_28, [getRole(6) ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("input", {
                  type: "file",
                  ref_key: "filebtn_i",
                  ref: filebtn_i,
                  onChange: $event => handle_file_selectted($event, '上传客户签名图纸', scope.$index),
                  style: {
                    "position": "absolute",
                    "top": "0",
                    "right": "0",
                    "width": "100%",
                    "height": "100%",
                    "opacity": "0",
                    "cursor": "pointer"
                  }
                }, null, 40, _hoisted_30), _cache[39] || (_cache[39] = _createElementVNode("span", {
                  class: "link iconfont icon-shangchuanfujian"
                }, null, -1))])) : _createCommentVNode("", true), _createElementVNode("span", {
                  onClick: $event => handle_click_url(scope.row.sign_drawing.file_url),
                  class: "pointers link"
                }, _toDisplayString(scope.row.sign_drawing.file_name) + "  ", 9, _hoisted_31), scope.row.sign_drawing.file_name && getRole(6) ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "iconfont icon-shanchu",
                  onClick: $event => handle_delete_drawing(scope.$index, 'sign_drawing')
                }, null, 8, _hoisted_32)) : _createCommentVNode("", true)])]),
                _: 1
              }), getRole(4) || getRole(6) || getRole(5) && data.link_detail.table && data.link_detail.table[0] ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                label: "操作",
                prop: "sign_drawing",
                width: "60"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
                  title: "你确定要删除吗?",
                  onConfirm: $event => handleConfirm(scope.$index)
                }, {
                  reference: _withCtx(() => _cache[40] || (_cache[40] = [_createElementVNode("span", {
                    class: "iconfont icon-shanchu"
                  }, null, -1)])),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["data"])) : _createCommentVNode("", true)]), data.link_detail.type == 3 && getRole(4) ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: "add pointers",
              onClick: handle_add_material
            }, _cache[41] || (_cache[41] = [_createElementVNode("span", {
              class: "iconfont icon-tianjia"
            }, null, -1), _createTextVNode(" 添加 ")]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.renwu, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "detail_renwu_item",
                style: {
                  "position": "relative"
                }
              }, [item.selected.findIndex(m => m.status != 2) != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_34)) : (_openBlock(), _createElementBlock("span", _hoisted_35)), data.link_detail.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [item.type > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(getTypeLabel(item.type)) + "： ", 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.selected, (v, i) => {
                return _openBlock(), _createElementBlock("div", {
                  key: i
                }, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", {
                  class: _normalizeClass({
                    link: v.link_user_id == _unref(userStore).info.id,
                    nameshow: true
                  })
                }, _toDisplayString(v.name), 3), _cache[42] || (_cache[42] = _createTextVNode("  ")), v.status == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_39)) : _createCommentVNode("", true), v.status != 2 && v.status != 4 && (_unref(userStore).info.id == v.link_user_id || _unref(userStore).info.id == data.link_detail.user_id) ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "link pointers btncomplete iconfont icon-ziyuan165",
                  onClick: $event => handle_complete(v, item)
                }, "  确认", 8, _hoisted_40)) : _createCommentVNode("", true)])]);
              }), 128))])) : _createCommentVNode("", true), data.link_detail.type == 2 || data.link_detail.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [item.type ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(getTypeLabel(item.type)) + "： ", 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.selected, (v, i) => {
                return _openBlock(), _createElementBlock("div", {
                  key: i
                }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("span", {
                  class: _normalizeClass({
                    link: v.link_user_id == _unref(userStore).info.id,
                    nameshow: true
                  })
                }, _toDisplayString(v.name), 3), _cache[43] || (_cache[43] = _createTextVNode("  ")), v.status == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_44)) : _createCommentVNode("", true), v.status != 2 && _unref(userStore).info.id == v.link_user_id && data.link_detail.status != 4 ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "link pointers btncomplete iconfont icon-ziyuan165",
                  onClick: $event => handle_complete(v, item)
                }, "  确认", 8, _hoisted_45)) : _createCommentVNode("", true)])]);
              }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, _toDisplayString(data.link_detail.type == 1 ? "任务描述：" : "协同任务："), 1), item.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createTextVNode(_toDisplayString(item.title) + "   ", 1), item.selected.findIndex(x => x.link_user_id == _unref(userStore).info.id) != -1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "iconfont icon-buhuo blk_link",
                onClick: $event => handle_buhuo(item),
                style: {
                  "font-size": "18px"
                }
              }, null, 8, _hoisted_49)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.link_detail.wuliu_arr, (m, n) => {
                return _openBlock(), _createElementBlock("div", {
                  key: n
                }, [data.link_detail.wuliu_arr.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_50, [n == 0 && !item.show_wuliu && data.link_detail.wuliu_arr.length > 1 ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {
                    "display": "inline-block",
                    "width": "20px"
                  },
                  class: "iconfont icon-jiantoushang blk_link",
                  onClick: _withModifiers($event => item.show_wuliu = !item.show_wuliu, ["stop"])
                }, null, 8, _hoisted_51)) : _createCommentVNode("", true), n == 0 && item.show_wuliu && item.content.split(',').length > 1 ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  style: {
                    "display": "inline-block",
                    "width": "20px"
                  },
                  class: "iconfont icon-jiantouxia blk_link",
                  onClick: _withModifiers($event => item.show_wuliu = !item.show_wuliu, ["stop"])
                }, null, 8, _hoisted_52)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), n == 0 || item.show_wuliu ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "blk_link",
                  onClick: $event => handle_show_wuliuInfo(m),
                  style: {
                    "cursor": "pointer"
                  }
                }, [n >= 1 ? (_openBlock(), _createElementBlock("span", _hoisted_54)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(m) + "   ", 1)], 8, _hoisted_53)) : _createCommentVNode("", true), item.selected.findIndex(x => x.link_user_id == _unref(userStore).info.id) != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_55, [n == 0 || item.show_wuliu ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {
                    "color": "#b1b1b1",
                    "font-size": "30rpx"
                  },
                  class: "iconfont icon-bianjisekuai",
                  onClick: _withModifiers($event => handle_edit_wuliu(m, n), ["stop"])
                }, "  ", 8, _hoisted_56)) : _createCommentVNode("", true), n == 0 || item.show_wuliu ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 1,
                  width: "220",
                  "confirm-button-text": "确定",
                  "cancel-button-text": "取消",
                  title: "确定删除该物流单号?",
                  onConfirm: $event => handle_del_wuliu(m, n)
                }, {
                  reference: _withCtx(() => _cache[44] || (_cache[44] = [_createElementVNode("span", {
                    class: "iconfont icon-shanchu",
                    style: {
                      "color": "red"
                    }
                  }, "  ", -1)])),
                  _: 2
                }, 1032, ["onConfirm"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
              }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(item.title), 1))]), _createElementVNode("div", null, "截止时间：" + _toDisplayString(item.finish_time), 1), _createElementVNode("div", null, "确认时间：" + _toDisplayString(item.confirm_time), 1), _createVNode(_component_el_divider)]);
            }), 128))]), _createElementVNode("div", _hoisted_58, [_cache[45] || (_cache[45] = _createElementVNode("span", {
              class: "iconfont icon-lianxiren",
              style: {
                "font-size": "20px"
              }
            }, null, -1)), _cache[46] || (_cache[46] = _createTextVNode("  ")), _createElementVNode("div", _hoisted_59, [data.showOperate ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "operate",
              onMouseleave: _cache[7] || (_cache[7] = $event => data.showOperate = false)
            }, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.munulist, (v, i) => {
              return _openBlock(), _createElementBlock("span", {
                class: _normalizeClass({
                  txt: true,
                  blk_primary: data.current_menus == v.value
                }),
                onClick: $event => changeMenus(v),
                key: i
              }, _toDisplayString(v.name), 11, _hoisted_62);
            }), 128))]), data.arr_choose_list && data.arr_choose_list[0] ? (_openBlock(), _createElementBlock("div", _hoisted_63, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.arr_choose_list, (v, i) => {
              return _openBlock(), _createElementBlock("div", {
                class: "members_list",
                key: i
              }, [_createElementVNode("div", _hoisted_64, [_createElementVNode("span", _hoisted_65, _toDisplayString(v.user_name + ":" + v.title), 1), _createElementVNode("span", _hoisted_66, [v.status != 2 && v.link_user_id != _unref(userStore).info.id && data.link_detail.type != 3 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "iconfont icon-cuiban",
                style: {
                  "font-size": "20px"
                },
                onClick: $event => handle_operate(v, 3)
              }, null, 8, _hoisted_67)) : _createCommentVNode("", true), v.link_user_id != _unref(userStore).info.id && v.status != 2 && data.link_detail.type == 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                class: "box-item",
                effect: "dark",
                content: "移除成员",
                placement: "top"
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "iconfont icon-yichuchengyuan",
                  onClick: $event => handle_operate(v, 2)
                }, null, 8, _hoisted_68)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), (_unref(userStore).info.id == data.link_detail.user_id || data.link_detail != 1) && v.status == 2 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 2,
                class: "box-item",
                effect: "dark",
                content: "标记为未完成",
                placement: "top"
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "iconfont icon-weiwancheng",
                  onClick: $event => handle_operate(v, 1)
                }, null, 8, _hoisted_69)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), v.status != 2 && data.link_detail.type == 1 && (v.link_user_id == _unref(userStore).info.id || _unref(userStore).info.id == data.link_detail.user_id) ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 3,
                class: "box-item",
                effect: "dark",
                content: "标记为完成",
                placement: "top"
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "iconfont icon-ziyuan165",
                  onClick: $event => handle_operate(v, 4)
                }, null, 8, _hoisted_70)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)])])]);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_71, " 无数据 "))])], 32)) : _createCommentVNode("", true), _createElementVNode("p", {
              style: {
                "border": "1px solid #ccc",
                "padding": "0 10px",
                "border-radius": "15px",
                "cursor": "pointer"
              },
              onClick: handle_showOperate,
              onMouseover: handle_mouse_enter_operate
            }, _toDisplayString(data.description), 33)])]), _createElementVNode("div", null, [_cache[47] || (_cache[47] = _createElementVNode("span", {
              class: "iconfont icon-jiezhishijian"
            }, null, -1)), _createTextVNode("   " + _toDisplayString(data.link_detail.type == 2 ? "预计返厂时间：" : "截止时间：") + _toDisplayString(data.link_detail.date), 1)]), data.link_detail.type != 3 && data.link_detail.file && data.link_detail.file[0] ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_cache[48] || (_cache[48] = _createElementVNode("span", null, "附件：", -1)), _createElementVNode("div", _hoisted_73, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.link_detail.file, (v, i) => {
              return _openBlock(), _createElementBlock("div", {
                key: i
              }, [data.show_file && i != 0 || i == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_74, [i == 0 && data.link_detail.file.length > 1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass({
                  iconfont: true,
                  'icon-jiantouxia': !data.show_file,
                  'icon-jiantoushang': data.show_file
                }),
                onClick: _cache[8] || (_cache[8] = _withModifiers($event => data.show_file = !data.show_file, ["stop"]))
              }, " ", 2)) : _createCommentVNode("", true), i > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_75, " ")) : _createCommentVNode("", true), _createElementVNode("span", {
                style: {
                  "display": "inline-block",
                  "width": "90%"
                },
                onClick: $event => handle_click_url(v.file_url)
              }, _toDisplayString(v.name), 9, _hoisted_76)])) : _createCommentVNode("", true)]);
            }), 128))])])) : _createCommentVNode("", true), _createVNode(_component_common_area, {
              id: data.link_id,
              comment_type: 3,
              showLike: false,
              showVisit: false
            }, null, 8, ["id"])])];
          }),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "操作记录",
          name: "reamrk",
          style: {
            "margin-top": "10px",
            "margin-left": "5px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_timeline, {
            style: {
              "height": "450px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.link_detail.log, (activity, index) => {
              return _openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: activity.timestamp
              }, {
                default: _withCtx(() => [_createElementVNode("p", _hoisted_77, _toDisplayString(activity.content), 1)]),
                _: 2
              }, 1032, ["timestamp"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }), data.link_detail.type == 3 ? (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: 0,
          label: data.link_detail.copy.length ? '历史记录(' + data.link_detail.copy.length + ')' : '历史记录',
          name: "history"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_78, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.link_detail.copy, (v, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              style: {
                "margin-bottom": "10px"
              }
            }, [_createElementVNode("div", _hoisted_79, [_createElementVNode("div", null, [_createElementVNode("i", {
              class: _normalizeClass({
                iconfont: true,
                'icon-jiantoushang': !v.show,
                'icon-jiantouxia': v.show,
                blk_link: true
              }),
              onClick: $event => v.show = !v.show
            }, null, 10, _hoisted_80), _cache[49] || (_cache[49] = _createTextVNode("   ")), _createElementVNode("span", _hoisted_81, _toDisplayString(v.theme), 1)]), _createElementVNode("div", null, _toDisplayString(v.created_at), 1)]), v.show ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, "申请人：" + _toDisplayString(v.create_user), 1), _createElementVNode("div", _hoisted_84, [_createTextVNode(" 客户需求：" + _toDisplayString(v.title) + " ", 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.file, (m, n) => {
              return _openBlock(), _createElementBlock("div", {
                style: {
                  "line-height": "20px",
                  "padding-left": "5em"
                },
                key: n
              }, [v.show_file && n != 0 || n == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_85, [n == 0 && v.file.length > 1 ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass({
                  iconfont: true,
                  blk_link: true,
                  'icon-jiantoushang': !v.show_file,
                  'icon-jiantouxia': v.show_file
                }),
                onClick: _withModifiers($event => v.show_file = !v.show_file, ["stop"])
              }, " ", 10, _hoisted_86)) : _createCommentVNode("", true), n > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_87, " ")) : _createCommentVNode("", true), _createElementVNode("span", {
                class: "blk_link",
                style: {
                  "display": "inline-block",
                  "width": "90%",
                  "cursor": "pointer"
                },
                onClick: $event => handle_click_url(m.file_url)
              }, _toDisplayString(m.name), 9, _hoisted_88)])) : _createCommentVNode("", true)]);
            }), 128))]), _createVNode(_component_el_table, {
              data: v.table,
              border: "",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "序列",
                width: "55"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.$index + 1), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "规格型号",
                prop: "bd_material_model",
                width: "120",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.bd_material_model ? scope.row.bd_material_model : "-"), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "物料名称",
                width: "150",
                prop: "bd_material_name",
                "show-overflow-tooltip": ""
              }), _createVNode(_component_el_table_column, {
                label: "bom版本",
                prop: "bd_material_versions",
                width: "100"
              }), _createVNode(_component_el_table_column, {
                label: "产品图纸",
                prop: "drawing"
              }, {
                header: _withCtx(() => [_createElementVNode("div", _hoisted_89, [_cache[50] || (_cache[50] = _createTextVNode(" 产品图纸   ")), _createElementVNode("span", {
                  class: "blk_link iconfont icon-xiazai",
                  onClick: $event => handle_download(1, data.link_id, v.num)
                }, null, 8, _hoisted_90)])]),
                default: _withCtx(scope => {
                  var _scope$row$drawing;
                  return [_createElementVNode("div", _hoisted_91, [_createElementVNode("span", {
                    onClick: $event => handle_click_url(scope.row.drawing.file_url),
                    class: "pointers blk_link"
                  }, _toDisplayString((_scope$row$drawing = scope.row.drawing) === null || _scope$row$drawing === void 0 ? void 0 : _scope$row$drawing.file_name) + "   ", 9, _hoisted_92)])];
                }),
                _: 2
              }, 1024), _createVNode(_component_el_table_column, {
                label: "签字图纸",
                prop: "sign_drawing"
              }, {
                header: _withCtx(() => [_createElementVNode("div", _hoisted_93, [_cache[51] || (_cache[51] = _createTextVNode(" 签字图纸   ")), _createElementVNode("span", {
                  class: "blk_link iconfont icon-xiazai",
                  onClick: $event => handle_download(2, data.link_id, v.num)
                }, null, 8, _hoisted_94)])]),
                default: _withCtx(scope => {
                  var _scope$row$sign_drawi;
                  return [_createElementVNode("div", _hoisted_95, [_createElementVNode("span", {
                    onClick: $event => handle_click_url(scope.row.sign_drawing.file_url),
                    class: "pointers link"
                  }, _toDisplayString((_scope$row$sign_drawi = scope.row.sign_drawing) === null || _scope$row$sign_drawi === void 0 ? void 0 : _scope$row$sign_drawi.file_name) + "  ", 9, _hoisted_96)])];
                }),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["data"])])) : _createCommentVNode("", true)]);
          }), 128))])]),
          _: 1
        }, 8, ["label"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_97, "无权限查看")), _createVNode(_component_el_dialog, {
        "destroy-on-close": "",
        modelValue: data.showCloseDemo,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => data.showCloseDemo = $event),
        width: "500",
        title: "关闭待办",
        "append-to-body": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_createVNode(_component_el_input, {
          modelValue: data.close_cause,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => data.close_cause = $event),
          placeholder: "请输入关闭原因",
          type: "textarea",
          border: true
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_100, [_createElementVNode("span", {
          class: "cancle btn",
          onClick: _cache[11] || (_cache[11] = $event => data.showCloseDemo = false)
        }, "取消"), _cache[52] || (_cache[52] = _createTextVNode("     ")), _createElementVNode("span", {
          class: "confirm btn",
          onClick: _cache[12] || (_cache[12] = $event => handle_submit_desc('close_cause'))
        }, "提交")])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        "destroy-on-close": "",
        modelValue: data.dialogVisible_wl,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => data.dialogVisible_wl = $event),
        width: "700",
        title: "选择父项物料",
        "append-to-body": "",
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(selectMaterial, {
          onGetSelectData: getSelectData
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: data.buhuo_dialog,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => data.buhuo_dialog = $event),
        "append-to-body": "",
        "destroy-on-close": "",
        "show-close": "",
        title: "物流单号/补货"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: data.buhuo_num,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => data.buhuo_num = $event),
          placeholder: "请输入物流单号"
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_101, [_createVNode(_component_el_button, {
          type: "plain",
          onClick: _cache[16] || (_cache[16] = $event => data.buhuo_dialog = false)
        }, {
          default: _withCtx(() => _cache[53] || (_cache[53] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[17] || (_cache[17] = $event => pass_buhuo(1))
        }, {
          default: _withCtx(() => _cache[54] || (_cache[54] = [_createTextVNode("确定")])),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: data.editwuliu_dialog,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => data.editwuliu_dialog = $event),
        "append-to-body": "",
        "destroy-on-close": "",
        "show-close": "",
        title: "编辑物流单号"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: data.edit_wuliu_num,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => data.edit_wuliu_num = $event),
          placeholder: "请输入物流单号"
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_102, [_createVNode(_component_el_button, {
          type: "plain",
          onClick: _cache[20] || (_cache[20] = $event => data.editwuliu_dialog = false)
        }, {
          default: _withCtx(() => _cache[55] || (_cache[55] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[21] || (_cache[21] = $event => pass_buhuo(2))
        }, {
          default: _withCtx(() => _cache[56] || (_cache[56] = [_createTextVNode("确定")])),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_drawer, {
        modelValue: data.showWuliu,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => data.showWuliu = $event),
        title: data.wuliuDrawerTitle,
        direction: "rtl"
      }, {
        default: _withCtx(() => [activities.value.com_name ? (_openBlock(), _createElementBlock("h5", _hoisted_103, " 承运方:" + _toDisplayString(activities.value.com_name), 1)) : _createCommentVNode("", true), activities.value.trailUrl ? (_openBlock(), _createElementBlock("iframe", {
          key: 1,
          src: activities.value.trailUrl,
          style: {
            "width": "100%"
          },
          frameborder: "0"
        }, null, 8, _hoisted_104)) : _createCommentVNode("", true), activities.value.data ? (_openBlock(), _createBlock(_component_el_timeline, {
          key: 2
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value.data, (activity, index) => {
            return _openBlock(), _createBlock(_component_el_timeline_item, {
              placement: "top",
              key: index,
              timestamp: activity.time,
              color: index == 0 ? '#007aff' : '#0bbd87'
            }, {
              default: _withCtx(() => [_createVNode(_component_el_card, null, {
                default: _withCtx(() => [_createElementVNode("h4", _hoisted_105, "状态：" + _toDisplayString(activity.status), 1), activity.areaName ? (_openBlock(), _createElementBlock("p", _hoisted_106, " 到达地点：" + _toDisplayString(activity.areaName), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_107, _toDisplayString(activity.context), 1), _createElementVNode("p", _hoisted_108, _toDisplayString(activity.time), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["timestamp", "color"]);
          }), 128))]),
          _: 1
        })) : (_openBlock(), _createElementBlock("span", _hoisted_109, "暂无物流信息"))]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }
};